const autocompleteUrl = '/api/v1/search/autocomplete';

export function fetchAutocompleteResults(searchTerm: string, size: number = 5) {
    return window.fetch(`${autocompleteUrl}/${searchTerm}/${size}`, {
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': (window as any).bootstrap?.apiKey,
        },
    })
        .then(function (response) {
            if (response.status === 504) {
                const errorMsg = new Error('Failed to fetch');
                errorMsg.message = 'Failed to fetch';
                throw errorMsg;
            } else if (response.status >= 400) {
                const errorMsg = new Error('Bad response');
                errorMsg.message = 'Bad response';
                throw errorMsg;
            }
            return response.json();
        }).then(data => data);
}